// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3RGLK","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__p7tWk"};